import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { RiMenu3Line } from "react-icons/ri";
import { logoutUser } from "../actions/userLogout";
import { AlertContext, UserContext } from "../context/MainContext";
import { BsChevronDown } from "react-icons/bs";
import { cloudinaryUrl } from "../constants/CloudinaryConstants";
import ReportModal from "./ReportModal";
import { ENABLE_KEYS } from "../constants/FeatureFlags";
const Nav = () => {
  const { user, setUser } = useContext(UserContext);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const { setAlert } = useContext(AlertContext);
  const nav = useNavigate();
  const isAdmin = user?.user_id === 3 || user?.user_id === 16;
  const canManageProps = user?.class_type === "Realtor" || isAdmin;

  const handleLogout = () => {
    logoutUser({ setUser });
    setAlert(["Logout Success!", "You have been logged out.", "confirm"]);
    nav("/");
  };
  return (
    <>
      {mobileMenu && (
        <nav className="nav:hidden z-[60] absolute top-0 left-0 w-screen h-screen bg-[color:var(--main-blue)] flex flex-col gap-8 items-center justify-center text-white font-medium text-30">
          <Link
            to="/"
            className="hover:cursor-pointer"
            onClick={() => setMobileMenu(false)}
          >
            Home
          </Link>
          <div className="flex flex-col gap-3 items-center">
            <Link
              className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
              to="/professionals"
              onClick={() => setAlert(false)}
            >
              Professionals
            </Link>
            <Link
              className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
              to="/keys"
              onClick={() => setAlert(false)}
            >
              Keys
            </Link>
            {/* <Link
              to="/about"
              className="hover:cursor-pointer"
              onClick={() => setMobileMenu(false)}
            >
              About myLLave
            </Link>
            <Link
              to="/keys"
              className="hover:cursor-pointer"
              onClick={() => setMobileMenu(false)}
            >
              What are Keys?
            </Link> */}
            <Link
              className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
              to="/store"
              onClick={() => setAlert(false)}
            >
              Store
            </Link>
            {user ? (
              <Link
                to="/residentialAdd"
                className="hover:cursor-pointer"
                onClick={() => setMobileMenu(false)}
              >
                List A Property
              </Link>
            ) : (
              ""
            )}
            {isAdmin && (
              <Link
                to="/adminpanell"
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg"
                onClick={() => setMobileMenu(false)}
              >
                Admin Panel
              </Link>
            )}
            {/* <Link to="/register" className="hover:cursor-pointer">Register</Link> */}
          </div>
        </nav>
      )}
      <div className="flex flex-col">
        <nav className="flex justify-between items-center bg-[color:var(--main-blue)] px-16 text-white">
          <div className="flex gap-3 items-center justify-center">
            <Link
              to="/"
              className="text-52 pl-4 flex hover:scale-105 transition-all"
            >
              my<p className="text-yellow-300">Llave</p>
            </Link>
            <span className="ml-3 text-sm text-white/90 hidden md:inline">
              Welcome Home
            </span>
          </div>
          <div className=" gap-6 text-19 hidden nav:flex justify-center items-center">
            <div className=" text-white group relative select-none">
              <div className="flex gap-2 items-center">
                <h1>Properties</h1>
                <BsChevronDown size={22} />
              </div>
              <div className="absolute z-50 hidden text-center bg-[color:var(--main-blue)] border-2  w-[200px] group-hover:flex group-hover:flex-col gap-2 py-4">
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/active"
                  onClick={() => setAlert(false)}
                >
                  Active
                </Link>
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/leased"
                  onClick={() => setAlert(false)}
                >
                  Leased
                </Link>
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/sold"
                  onClick={() => setAlert(false)}
                >
                  Sold
                </Link>
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/pending"
                  onClick={() => setAlert(false)}
                >
                  Pending
                </Link>
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/offmarket"
                  onClick={() => setAlert(false)}
                >
                  Temporarily Off Market
                </Link>
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/withdrawn"
                  onClick={() => setAlert(false)}
                >
                  Withdrawn
                </Link>
                <Link
                  className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                  to="/expired"
                  onClick={() => setAlert(false)}
                >
                  Expired
                </Link>
              </div>
            </div>

            <Link
              className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
              to="/professionals"
              onClick={() => setAlert(false)}
            >
              Professionals
            </Link>
            <Link
              className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
              to="/keys"
              onClick={() => setAlert(false)}
            >
              Keys
            </Link>
            <Link
              className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
              to="/store"
              onClick={() => setAlert(false)}
            >
              Store
            </Link>
            {user?.class_type === "Realtor" ||
            user?.class_type === "Builder" ||
            user?.class_type === "Investor" ? (
              <Link
                className="hover:text-white hover:bg-black bg-white text-black rounded-10 p-2 font-semibold  hover:cursor-pointer transition-all"
                to="/residentialAdd"
                onClick={() => setAlert(false)}
              >
                List A Property
              </Link>
            ) : (
              ""
            )}
            {!user ? (
              <Link
                className="bg-white text-blue-600 px-4 py-2 rounded-lg font-semibold hover:bg-gray-100 hover:cursor-pointer transition-all"
                to="/login"
                onClick={() => setAlert(false)}
              >
                Login
              </Link>
            ) : (
              // <Link className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all" to="/profile" onClick={()=>setAlert(false)}><img className="h-[45px] w-[45px] object-cover rounded-full" src={user?.picture_url ? cloudinaryUrl(user?.picture_url) : '/error.png'} alt="profile"/></Link>
              <div className="group relative">
                <img
                  className="h-[45px] w-[45px] object-cover rounded-full"
                  src={
                    user?.picture_url
                      ? cloudinaryUrl(user?.picture_url)
                      : "/error.png"
                  }
                  alt="profile"
                />
                <div className="absolute z-50 hidden text-center bg-[color:var(--main-blue)] border-2  w-[180px] group-hover:flex group-hover:flex-col gap-2 py-4">
                  <Link
                    className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                    to="/profile"
                    onClick={() => setAlert(false)}
                  >
                    My Profile
                  </Link>
                  {canManageProps && (
                    <>
                      <Link
                        className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                        to="/myproperties"
                        onClick={() => setAlert(false)}
                      >
                        My Properties
                      </Link>
                    </>
                  )}
                  {user?.class_type !== "" &&
                  user?.class_type !== "Consumer" ? (
                    <>
                      <Link
                        className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                        to="/addash"
                        onClick={() => setAlert(false)}
                      >
                        Ad Dashboard
                      </Link>
                      <Link
                        className="hover:text-[color:var(--main-yellow)] hover:cursor-pointer transition-all"
                        to="/adstore"
                        onClick={() => setAlert(false)}
                      >
                        Ad Store
                      </Link>
                    </>
                  ) : (
                    ""
                  )}
                  <button
                    className="bg-red-500 text-white px-4 py-2 rounded-10 hover:scale-105 hover:cursor-pointer transition-all mx-4"
                    onClick={handleLogout}
                  >
                    Log Out
                  </button>
                </div>
              </div>
            )}

            <div className="flex items-center gap-3">
              {isAdmin && (
                <Link
                  to="/adminpanell"
                  className="ml-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg"
                  onClick={() => setAlert(false)}
                >
                  Admin Panel
                </Link>
              )}
              {(user?.class_type === "Realtor" ||
                user?.class_type === "Builder" ||
                user?.class_type === "Broker" ||
                isAdmin) && (
                <Link
                  to="/residentialAdd"
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg"
                  onClick={() => setAlert(false)}
                >
                  Add Property
                </Link>
              )}
              {user && (
                <button
                  onClick={() => setShowReportModal(true)}
                  className="bg-yellow-500 hover:bg-yellow-600 text-white px-4 py-2 rounded-lg font-semibold transition-all shadow-md hover:shadow-lg"
                >
                  Report Issue
                </button>
              )}
            </div>
            {/* <Link to="/register" className="hover:cursor-pointer">Register</Link> */}
          </div>
          <RiMenu3Line
            className="hover:scale-105 hover:cursor-pointer transition-all text-white z-[61] block nav:hidden"
            size={30}
            onClick={() => setMobileMenu(!mobileMenu)}
          />
        </nav>
        {/* <nav className="bg-[color:var(--white)]  flex gap-6 items-center px-16 py-2 border-1">
                <input className="py-4 px-8 w-full border-2 rounded-10" type="text" placeholder="Coming Soon..."/>
                <p className="w-[10%]">Popular Categories</p>
                <p className="w-[10%]">Most Recent</p>
      </nav> */}
      </div>
      <ReportModal
        isOpen={showReportModal}
        onClose={() => setShowReportModal(false)}
      />
    </>
  );
};

export default Nav;
